import {
    Box,
    Divider,
    HStack,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Text,
    VStack,
} from "@chakra-ui/react";
import MyIcon from "../../components/Icon/MyIcon";
import { colors } from "../../styles";

export type CommentSortFilter = "latest" | "trending";

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    filter: CommentSortFilter;
    onChangeFilter: (filter: CommentSortFilter) => void;
}

const FILTER_OPTIONS: { value: CommentSortFilter; label: string }[] = [
    { value: "latest", label: "최신 순" },
    { value: "trending", label: "인기 순" },
];

export default function FilterModal(props: FilterModalProps) {

    const handleSelect = (filter: CommentSortFilter) => {
        props.onChangeFilter(filter);
        props.onClose();
    };

    return (
        <Modal
            motionPreset="slideInBottom"
            size="xs"
            isOpen={props.isOpen}
            onClose={props.onClose}
            isCentered
        >
            <ModalOverlay />
            <ModalContent borderRadius={16} overflow="hidden">
                <ModalBody padding={4}>
                    <VStack width="100%" spacing={0} alignItems="stretch">
                        {FILTER_OPTIONS.map((option, index) => (
                            <Box key={option.value}>
                                <HStack
                                    as="button"
                                    type="button"
                                    width="100%"
                                    justifyContent="center"
                                    alignItems="center"
                                    gap={2}
                                    paddingY={3}
                                    paddingX={2}
                                    onClick={() => handleSelect(option.value)}
                                >
                                    <Box width="20px" flexShrink={0}>
                                        {props.filter === option.value && (
                                            <MyIcon
                                                src="/svg/check-blue.svg"
                                                alt="선택됨"
                                                width={20}
                                                height={20}
                                            />
                                        )}
                                    </Box>
                                    <Text
                                        fontSize={16}
                                        fontWeight={props.filter === option.value ? 700 : 400}
                                        color={props.filter === option.value ? colors.blue : colors.g1}
                                    >
                                        {option.label}
                                    </Text>
                                </HStack>
                                {index < FILTER_OPTIONS.length - 1 && (
                                    <Divider borderColor={colors.g5} />
                                )}
                            </Box>
                        ))}
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
